export type RandomByteFiller = (target: Uint8Array) => Uint8Array;

export const createSecureUuid = (
  fillRandom: RandomByteFiller = (target) => crypto.getRandomValues(target),
): string => {
  const bytes = fillRandom(new Uint8Array(16));
  if (bytes.length !== 16) throw new Error("Unable to create a secure request identifier.");
  bytes[6] = (bytes[6]! & 0x0f) | 0x40;
  bytes[8] = (bytes[8]! & 0x3f) | 0x80;
  const hex = Array.from(bytes, (value) => value.toString(16).padStart(2, "0")).join("");
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
};
